import { z } from "zod";

export const CoverageStatus = z.enum(["Active", "Expired", "Cancelled"]);

export type CoverageStatusEnum = z.infer<typeof CoverageStatus>;

export const CoverageStatusDisplayName: Record<CoverageStatusEnum, string> = {
  [CoverageStatus.enum.Active]: "Active",
  [CoverageStatus.enum.Expired]: "Expired",
  [CoverageStatus.enum.Cancelled]: "Cancelled",
};
